// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import { css } from 'glamor';

import Markdown from '~/components/global/Markdown';

import type { User } from '~/types';

const contributor = css({
    height: '100%',

    '@media(max-width: 768px)': {
        marginTop: '30px',
    },
});

const titleRule = css({
    display: 'block',
    fontWeight: 300,
});

const name = css({
    display: 'block',
    fontWeight: 600,
});

const noMargin = css({
    display: 'inline-block',
    marginLeft: 0,
});

const nameInline = css({
    display: 'inline-block',

    '@media(max-width: 768px)': {
        marginLeft: '10px',
    },
});

const image = css({
    width: '80px',
    height: '80px',
});

const smallAvatarRule = css({
    width: '35px',
    height: '35px',
});

const fullImage = css({
    width: '100%',
    height: '150px',

    '@media(max-width: 768px)': {
        width: '80px',
        height: '80px',
    },
});

@observer
export default class Contributor extends React.Component {
    props: {
        user: User,
        title?: string,
        subtitle?: string,
        displayDetails?: boolean,
        noLink?: boolean,
        inline?: boolean,
        full?: boolean,
        smallAvatar?: boolean,
        noAvatar?: boolean,
        avatarRule?: any,
    };

    render() {
        const {
            user,
            title,
            subtitle,
            displayDetails,
            noLink,
            inline,
            full,
            smallAvatar,
            avatarRule,
            noAvatar,
        } = this.props;
        const avatarStyle = smallAvatar ? smallAvatarRule : null;

        if (!user) {
            return null;
        }

        if (full) {
            return (
                <div { ...contributor }>
                    <Row>
                        <Col md={ 2 }>
                            <Link to={ `/staff/${user.slug}` }>
                                <img
                                    { ...fullImage }
                                    src={ user.avatar.secure_url }
                                    alt={ user.name }
                                    title={ user.name }
                                    { ...avatarStyle }
                                    { ...avatarRule }
                                />
                            </Link>
                        </Col>
                        <Col md={ 10 }>
                            <div>
                                <span { ...titleRule }>
                                    {title}
                                </span>
                                {noLink ?
                                    <span { ...name }>
                                          {user.name}
                                      </span> :
                                    <Link to={ `/staff/${user.slug}` }>
                                          <span className="name" { ...name }>
                                              {user.name}
                                          </span>
                                      </Link>}
                                <span { ...titleRule }>
                                    {subtitle}
                                </span>
                            </div>
                            {user.description ?
                                <Markdown
                                    content={ user.description.brief.md }
                                /> :
                                null}
                        </Col>
                    </Row>
                </div>
            );
        }

        if (inline) {
            return (
                <div { ...contributor }>
                    {noAvatar ?
                        null :
                        <img
                            src={ user.avatar.secure_url }
                            alt={ user.name }
                            title={ user.name }
                            { ...image }
                            { ...avatarStyle }
                            { ...avatarRule }
                        />}
                    <span { ...css(name, noAvatar ? noMargin : nameInline) }>
                        {user.name}
                    </span>
                </div>
            );
        }

        if (!displayDetails) {
            return (
                <div { ...contributor }>
                    <Link to={ `/staff/${user.slug}` }>
                        <img
                            src={ user.avatar.secure_url }
                            alt={ user.name }
                            title={ user.name }
                            { ...image }
                            { ...avatarStyle }
                            { ...avatarRule }
                        />
                    </Link>
                </div>
            );
        }

        return (
            <div { ...contributor }>
                <Row>
                    <Col md={ 3 }>
                        <Link to={ `/staff/${user.slug}` }>
                            <img
                                src={ user.avatar.secure_url }
                                alt={ user.name }
                                title={ user.name }
                                { ...image }
                                { ...avatarStyle }
                                { ...avatarRule }
                            />
                        </Link>
                    </Col>
                    <Col md={ 9 }>
                        <div>
                            <span { ...titleRule }>
                                {title}
                            </span>
                            {noLink ?
                                <span { ...name }>
                                      {user.name}
                                  </span> :
                                <Link to={ `/staff/${user.slug}` }>
                                      <span { ...name }>
                                          {user.name}
                                      </span>
                                  </Link>}
                            <span { ...titleRule }>
                                {subtitle}
                            </span>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/Contributor/index.js